import { render } from "./desktop-menu.vue?vue&type=template&id=7972b5ba"
import script from "./desktop-menu.vue?vue&type=script&lang=js"
export * from "./desktop-menu.vue?vue&type=script&lang=js"

import "./desktop-menu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__